// extracted by mini-css-extract-plugin
export default {"theme-toggle-wrap":"ThemeToggle_theme-toggle-wrap__xZog3","theme-toggle":"ThemeToggle_theme-toggle__cJkTF","theme-icon":"ThemeToggle_theme-icon__pUkn+"};